import { parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

const format = (dateStr: string) => {
  if (!dateStr) {
    return '';
  }

  const date = parseISO(dateStr);

  const [d1, d2] = [new Date().getTime(), date.getTime()].sort((a, b) => a - b);

  const diff = Math.floor((d2 - d1) / 1000);
  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor((diff - hours * 3600) / 60);
  const seconds = diff - hours * 3600 - minutes * 60;

  const result = [];

  if (hours > 0) result.push(String(hours).padStart(2, '0'));

  result.push(String(minutes).padStart(2, '0'));
  result.push(String(seconds).padStart(2, '0'));

  return result.join(':');
};

type TimerProps = {
  startDate: string;
  play?: boolean;
};

export const Timer = ({ startDate, play }: TimerProps) => {
  const [time, setTime] = useState(format(startDate));

  useInterval(
    () => {
      setTime(format(startDate));
    },
    play ? 1000 : null,
  );

  useEffect(() => {
    setTime(format(startDate));
  }, [startDate]);

  return <>{time}</>;
};
